export default "__VITE_ASSET__a6ff5784__"